import ApiService from './ApiService';

class AddAsset {
  async initializeAddAsset(payload = {}) {
    try {
      const response = await ApiService.call('/secured/initialize_asset', 'POST', payload);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }
}
export default new AddAsset();
